import type { TetrominoType } from "./types";

export const COLORS: Record<TetrominoType, number> = {
  I: 0x5cf3ff,
  O: 0xffd76b,
  T: 0xb077ff,
  S: 0x6dff7a,
  Z: 0xff5d67,
  J: 0x66a1ff,
  L: 0xff9a4d
};

